import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import FaixaAmbiente from "./components/FaixaAmbiente";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import { AuthProvider } from "./contexts/AuthContext";
import { SyncProvider } from "./contexts/SyncContext";
import LayoutAdminPlataforma from "./layouts/LayoutAdminPlataforma";
import LayoutPrivado from "./layouts/LayoutPrivado";
import AdminPlataformaEmpresas from "./pages/AdminPlataforma/Empresas";
import AdminPlataformaLogin from "./pages/AdminPlataforma/Login";
import ConfiguracaoInicial from "./pages/ConfiguracaoInicial";
import GestaoColheitas from "./pages/Agricultura/Colheita";
import GestaoCulturas from "./pages/Agricultura/Culturas";
import AmostraSolo from "./pages/Agricultura/AmostraSolo";
import GestaoPlantios from "./pages/Agricultura/Plantios";
import GestaoAtividades from "./pages/Agricultura/RegAtividades";
import GestaoSafras from "./pages/Agricultura/Safras";
import GestaoTiposAtividade from "./pages/Agricultura/TiposAtividades";
import GestaoAcertoEstoque from "./pages/Almoxarifado/AcertoEstoque";
import GestaoCategorias from "./pages/Almoxarifado/Categorias";
import GestaoItensEstoque from "./pages/Almoxarifado/ItensEstoque";
import GestaoLocaisEstoque from "./pages/Almoxarifado/LocaisEstoque";
import GestaoMovimentacoesEstoque from "./pages/Almoxarifado/Movimentacoes";
import GestaoSubcategorias from "./pages/Almoxarifado/Subcategorias";
import GestaoUnidadesMedida from "./pages/Almoxarifado/UnidadeMedida";
import ConflitosSincronizacao from "./pages/Configuracoes/ConflitosSincronizacao";
import FilaOffline from "./pages/Configuracoes/FilaOffline";
import Permissoes from "./pages/Configuracoes/Permissoes";
import PerfisAcesso from "./pages/Configuracoes/PerfisAcesso";
import TrocarSenhaInicial from "./pages/Configuracoes/TrocarSenhaInicial";
import PlanosDeUso from "./pages/Configuracoes/PlanosDeUso";
import GestaoUsuarios from "./pages/Configuracoes/Usuarios";
import ConfiguracoesSistema from "./pages/Configuracoes/ConfiguracoesSistema";
import AssistenteIA from "./pages/Configuracoes/AssistenteIA";
import DadosEmpresa from "./pages/Configuracoes/DadosEmpresa";
import ConsultaAuditoria from "./pages/Auditoria/ConsultaAuditoria";
import GestaoFazendas from "./pages/Fazendas/Fazendas";
import GestaoFuncionarios from "./pages/Fazendas/Funcionarios";
import GestaoMaquinas from "./pages/Fazendas/Maquinas";
import GestaoTalhoes from "./pages/Fazendas/Talhoes";
import GestaoTiposMaquinas from "./pages/Fazendas/TiposMaquinas";
import GestaoFabricantesMaquinas from "./pages/Fazendas/FabricantesMaquinas";
import GestaoCategoriasFinanceiras from "./pages/Financeiro/CategoriaFinanceira";
import GestaoCategoriasMestra from "./pages/Financeiro/CategoriaMestra";
import GestaoCentroCusto from "./pages/Financeiro/CentroCusto";
import GestaoClientes from "./pages/Financeiro/Clientes";
import GestaoContasBancarias from "./pages/Financeiro/Conta";
import GestaoContasAPagar from "./pages/Financeiro/ContasAPagar";
import GestaoContasAReceber from "./pages/Financeiro/ContasAReceber";
import EntradaNota from "./pages/Financeiro/EntradaNota";
import GestaoFormasPagamento from "./pages/Financeiro/FormasPagamento";
import GestaoFornecedores from "./pages/Financeiro/Fornecedores";
import GestaoAnimais from "./pages/Pecuaria/Animais";
import BreteAjuste from "./pages/Pecuaria/Brete";
import GestaoEventosManejo from "./pages/Pecuaria/EvManejo";
import GestaoLotes from "./pages/Pecuaria/Lotes";
import GestaoMortalidade from "./pages/Pecuaria/Mortalidade";
import GestaoMovimentacoes from "./pages/Pecuaria/MovFiscal";
import GestaoNatalidade from "./pages/Pecuaria/Natalidade";
import GestaoPastos from "./pages/Pecuaria/Pastos";
import GestaoPesagens from "./pages/Pecuaria/Pesagem";
import GestaoRotacaoPastos from "./pages/Pecuaria/RotacaoPastos";
import GestaoTiposManejo from "./pages/Pecuaria/TipoManejo";
import AnaliseSolo from "./pages/Relatorios/Agricolas/AnaliseSolo";
import RelatorioAplicacaoInsumos from "./pages/Relatorios/Agricolas/AplicInsumos";
import RelatorioCustoHectare from "./pages/Relatorios/Agricolas/CustoHectare";
import MonitClimaIrri from "./pages/Relatorios/Agricolas/MonitClimaIrri";
import RelatorioPlantioColheita from "./pages/Relatorios/Agricolas/PlantioColheita";
import RelatorioProdutividadeTalhao from "./pages/Relatorios/Agricolas/ProdTalhao";
import RelatorioEstoqueAtualizado from "./pages/Relatorios/Almoxarifado/EstoqueAtu";
import RelatorioMovimentacaoEstoque from "./pages/Relatorios/Almoxarifado/MovEstoque";
import RelatorioCadastros from "./pages/Relatorios/Cadastros/RelatorioCadastros";
import RelatorioFinanceiro from "./pages/Relatorios/Financeiros/ContasPagarReceber";
import RelatorioCustoPorAtividade from "./pages/Relatorios/Financeiros/CustoAtiv";
import RelatorioAtividadesFinanceiro from "./pages/Relatorios/Financeiros/AtividadesFinanceiro";
import OrcamentoRealiz from "./pages/Relatorios/Financeiros/OrcamentoRealiz";
import RelatorioRentabilidade from "./pages/Relatorios/Financeiros/Rentabilidade";
import RentabiMapaAplicInsumos from "./pages/Relatorios/Georreferenciamento e Mapas/MapaAplicInsumos";
import MapaProdTalhao from "./pages/Relatorios/Georreferenciamento e Mapas/MapaProdTalhao";
import RelatorioConformidadeRastreabilidade from "./pages/Relatorios/Gestao e Desempenho/ConformRastrea";
import DashboardKPIs from "./pages/Relatorios/Gestao e Desempenho/KPIs";
import AlertasPred from "./pages/Relatorios/IA Integrada/AlertasPred";
import InsightsAuto from "./pages/Relatorios/IA Integrada/InsightsAuto";
import CotHist from "./pages/Relatorios/Mercado e Precos/CotHist";
import RecomenVenda from "./pages/Relatorios/Mercado e Precos/RecomenVenda";
import RelatorioControleEstoqueAnimais from "./pages/Relatorios/Pecuarios/ControleEstAnim";
import RelatorioGanhoPeso from "./pages/Relatorios/Pecuarios/GanhoPeso";
import RelatorioReproducao from "./pages/Relatorios/Pecuarios/Reproducao";
import RelatorioSanidadePecuaria from "./pages/Relatorios/Pecuarios/SanidadePecuaria";

function App() {
  return (
    <AuthProvider>
      <SyncProvider>
      <FaixaAmbiente />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />

          {/* Usuário admin auto-criado ao cadastrar empresa (sem fazenda
              ainda) — cria a primeira fazenda antes de entrar no sistema. */}
          <Route path="/configuracao-inicial" element={<ConfiguracaoInicial />} />

          {/* Troca de senha obrigatória no primeiro acesso — fora do
              LayoutPrivado para não entrar em loop de redirect. */}
          <Route path="/trocar-senha" element={<TrocarSenhaInicial />} />

          {/* Administração da plataforma (superusuários Django) — fora do
              fluxo de CNPJ/fazenda dos clientes, layout próprio */}
          <Route path="/admin-plataforma/login" element={<AdminPlataformaLogin />} />
          <Route element={<LayoutAdminPlataforma />}>
            <Route path="/admin-plataforma/empresas" element={<AdminPlataformaEmpresas />} />
          </Route>

          <Route element={<LayoutPrivado />}>
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Fazendas */}
            <Route path="/fazendas/fazendas" element={<GestaoFazendas />} />
            <Route path="/fazendas/talhoes" element={<GestaoTalhoes />} />
            <Route path="/fazendas/maquinas" element={<GestaoMaquinas />} />
            <Route
              path="/fazendas/funcionarios"
              element={<GestaoFuncionarios />}
            />
            <Route
              path="/fazendas/tipos-maquina"
              element={<GestaoTiposMaquinas />}
            />
            <Route
              path="/fazendas/fabricantes-maquina"
              element={<GestaoFabricantesMaquinas />}
            />

            {/* Pecuária */}
            <Route path="/pecuaria/animais" element={<GestaoAnimais />} />
            <Route
              path="/pecuaria/eventos_manejo"
              element={<GestaoEventosManejo />}
            />
            <Route path="/pecuaria/lotes" element={<GestaoLotes />} />
            <Route
              path="/pecuaria/mortalidade"
              element={<GestaoMortalidade />}
            />
            <Route path="/pecuaria/pesagem" element={<GestaoPesagens />} />
            <Route
              path="/pecuaria/mov_fiscal"
              element={<GestaoMovimentacoes />}
            />
            <Route path="/pecuaria/natalidade" element={<GestaoNatalidade />} />
            <Route path="/pecuaria/pastos" element={<GestaoPastos />} />
            <Route
              path="/pecuaria/rotacao_pastos"
              element={<GestaoRotacaoPastos />}
            />
            <Route
              path="/pecuaria/tipomanejo"
              element={<GestaoTiposManejo />}
            />
            <Route path="/pecuaria/brete" element={<BreteAjuste />} />

            {/* Agricultura */}
            <Route path="/agricultura/culturas" element={<GestaoCulturas />} />
            <Route path="/agricultura/analise-solo" element={<AmostraSolo />} />
            <Route path="/agricultura/plantios" element={<GestaoPlantios />} />
            <Route path="/agricultura/safras" element={<GestaoSafras />} />
            <Route
              path="/agricultura/RegAtividades"
              element={<GestaoAtividades />}
            />
            <Route path="/agricultura/colheita" element={<GestaoColheitas />} />
            <Route
              path="/agricultura/tipoatividade"
              element={<GestaoTiposAtividade />}
            />

            {/* Financeiro */}
            <Route path="/financeiro/entrada-nota" element={<EntradaNota />} />
            <Route
              path="/financeiro/contas-pagar"
              element={<GestaoContasAPagar />}
            />
            <Route
              path="/financeiro/contas-receber"
              element={<GestaoContasAReceber />}
            />
            <Route path="/financeiro/clientes" element={<GestaoClientes />} />
            <Route
              path="/financeiro/fornecedores"
              element={<GestaoFornecedores />}
            />
            <Route
              path="/financeiro/formas-pagamento"
              element={<GestaoFormasPagamento />}
            />
            <Route
              path="/financeiro/categoria-financeira"
              element={<GestaoCategoriasFinanceiras />}
            />
            <Route
              path="/financeiro/categoria-mestra"
              element={<GestaoCategoriasMestra />}
            />
            <Route
              path="/financeiro/centro-custo"
              element={<GestaoCentroCusto />}
            />
            <Route
              path="/financeiro/conta"
              element={<GestaoContasBancarias />}
            />

            {/* Almoxarifado */}
            <Route
              path="/almoxarifado/categorias"
              element={<GestaoCategorias />}
            />
            <Route
              path="/almoxarifado/subcategorias"
              element={<GestaoSubcategorias />}
            />
            <Route
              path="/almoxarifado/itensestoque"
              element={<GestaoItensEstoque />}
            />
            <Route
              path="/almoxarifado/locaisestoque"
              element={<GestaoLocaisEstoque />}
            />
            <Route
              path="/almoxarifado/movimentacoes"
              element={<GestaoMovimentacoesEstoque />}
            />
            <Route
              path="/almoxarifado/unidadesmedida"
              element={<GestaoUnidadesMedida />}
            />
            <Route
              path="/almoxarifado/acerto-estoque"
              element={<GestaoAcertoEstoque />}
            />

            {/* Relatórios */}
            <Route
              path="/relatorios/cadastros/cadastros"
              element={<RelatorioCadastros />}
            />
            <Route
              path="/relatorios/agricolas/analise-solo/:id"
              element={<AnaliseSolo />}
            />
            <Route
              path="/relatorios/agricolas/aplicacao-insumos"
              element={<RelatorioAplicacaoInsumos />}
            />
            <Route
              path="/relatorios/agricolas/custo-hectare"
              element={<RelatorioCustoHectare />}
            />
            <Route
              path="/relatorios/agricolas/monitclimairri"
              element={<MonitClimaIrri />}
            />
            <Route
              path="/relatorios/agricolas/plantiocolheita"
              element={<RelatorioPlantioColheita />}
            />
            <Route
              path="/relatorios/agricolas/produtividade-talhao"
              element={<RelatorioProdutividadeTalhao />}
            />
            <Route
              path="/relatorios/almoxarifado/est-atualizado/"
              element={<RelatorioEstoqueAtualizado />}
            />
            <Route
              path="/relatorios/almoxarifado/movimentacoes/"
              element={<RelatorioMovimentacaoEstoque />}
            />
            <Route
              path="/relatorios/financeiro/contas"
              element={<RelatorioFinanceiro />}
            />
            <Route
              path="/relatorios/financeiro/custo-atividade"
              element={<RelatorioCustoPorAtividade />}
            />
            <Route
              path="/relatorios/financeiro/atividades-financeiro"
              element={<RelatorioAtividadesFinanceiro />}
            />
            <Route
              path="/relatorios/financeiro/orcamento-realizado"
              element={<OrcamentoRealiz />}
            />
            <Route
              path="/relatorios/financeiro/rentabilidade"
              element={<RelatorioRentabilidade />}
            />
            <Route
              path="/relatorios/georreferenciamento e mapas/rentabimapaaplicinsumos"
              element={<RentabiMapaAplicInsumos />}
            />
            <Route
              path="/relatorios/georreferenciamento e mapas/mapaprodtalhao"
              element={<MapaProdTalhao />}
            />
            <Route
              path="/relatorios/conformidade/rastreabilidade"
              element={<RelatorioConformidadeRastreabilidade />}
            />
            <Route
              path="/relatorios/dashboard/kpis/"
              element={<DashboardKPIs />}
            />
            <Route
              path="/relatorios/IA integrada/alertaspred"
              element={<AlertasPred />}
            />
            <Route
              path="/relatorios/IA integrada/insightsauto"
              element={<InsightsAuto />}
            />
            <Route
              path="/relatorios/mercado e preços/cothist"
              element={<CotHist />}
            />
            <Route
              path="/relatorios/mercado e preços/recomenvenda"
              element={<RecomenVenda />}
            />
            <Route
              path="/relatorios/pecuarios/controleestanim"
              element={<RelatorioControleEstoqueAnimais />}
            />
            <Route
              path="/relatorios/pecuarios/ganho-peso/"
              element={<RelatorioGanhoPeso />}
            />
            <Route
              path="/relatorios/pecuarios/reproducao"
              element={<RelatorioReproducao />}
            />
            <Route
              path="/relatorios/pecuarios/sanidade"
              element={<RelatorioSanidadePecuaria />}
            />

            {/* Configurações */}
            <Route
              path="/configuracoes/usuarios"
              element={<GestaoUsuarios />}
            />
            <Route path="/configuracoes/permissoes" element={<Permissoes />} />
            <Route path="/configuracoes/perfis" element={<PerfisAcesso />} />
            <Route path="/configuracoes/planos" element={<PlanosDeUso />} />
            <Route
              path="/configuracoes/conflitos-sincronizacao"
              element={<ConflitosSincronizacao />}
            />
            <Route path="/configuracoes/sistema" element={<ConfiguracoesSistema />} />
            <Route path="/configuracoes/dados-empresa" element={<DadosEmpresa />} />
            <Route path="/configuracoes/assistente-ia" element={<AssistenteIA />} />
            <Route path="/auditoria/consulta" element={<ConsultaAuditoria />} />
            <Route
              path="/configuracoes/fila-offline"
              element={<FilaOffline />}
            />
          </Route>

          <Route path="*" element={<Login />} />
        </Routes>
      </BrowserRouter>
      </SyncProvider>
    </AuthProvider>
  );
}

export default App;
